import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditArmsfstatus = () => {
    const { state } = useLocation(); // Retrieve the state passed via navigation
    const navigate = useNavigate();

    // Initialize the form state with the received entry
    const [entry, setEntry] = useState({ ...state.entry });
    const [error, setError] = useState(null);

    useEffect(() => {
        setEntry({ ...state.entry }); // Reset form state when `state.entry` changes
    }, [state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    // Determine dashboard URL based on user role
    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'aruid') {
            return '/arms-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/arms-dashboard'; // Fallback to home
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        try {
            console.log("Sending updated entry:", entry);  // Debugging: Log the data before sending

            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit_feature/edit-arms.php', {
                action: 'update',
                ...entry,
            });

            console.log("Backend response:", response.data);  // Debugging: Log the backend response

            if (response.data?.status === 'success') {
                alert('Entry updated successfully!');
                navigate(getDashboardUrl()); // Redirect to the role-based dashboard
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
                alert(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="edit-form">
            <form>
                <div className="left-section">
                    <div>
                        <label>Token ID:</label>
                        <input
                            type="text"
                            name="token_id"
                            value={entry.token_id}
                            onChange={handleChange}
                            required
                        />
                    </div>
                   

                    
                    <div>
                        <label>Name:</label>
                        <input
                            type="text"
                            name="name"
                            value={entry.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label>Father Name:</label>
                        <input
                            type="text"
                            name="father_name"
                            value={entry.father_name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button type="button" onClick={handleSave}>
                        Update
                    </button>
                </div>
                <div className="right-section">
                    <div>
                        <label>CNIC:</label>
                        <input
                            type="text"
                            name="cnic"
                            value={entry.cnic}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label>Weapon Type:</label>
                        <input
                            type="text"
                            name="weapon"
                            value={entry.weapon}
                            onChange={handleChange}
                            required
                        />
                    </div>

                   
                    <div>
                        <label>Status:</label>
                        <select name="status" value={entry.status} onChange={handleChange}>
                            <option value="" disabled>Select Status</option>
                            <option value="Recieved">Recieved</option>
                            <option value="Ready">Ready</option>
                        </select>
                    </div>

                </div>
            </form>
        </div>
    );
};

export default EditArmsfstatus;
